import styled, { CSSObject } from 'styled-components';
import { ctxClass } from '../utils';

export const ctxSelectClass = ctxClass('select');

export const inputInnerStyle: () => CSSObject = () => ({
    outline: '0',
    flex: '1',
    padding: '0 0 0 10px',
    minWidth: '0',
    backgroundColor: 'transparent',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    border: '0',
    display: 'flex',
    alignItems: 'center',
});

export const SelectInput = styled.input`
    ${inputInnerStyle}
`;


export const PseudoInput = styled.div`
    ${inputInnerStyle}
`;
